export const ru = {
    accept: 'Применить',
    back: 'Назад',
    rest: 'И еще {count}, продолжайте печатать'
};
